import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'reports',
	loader: () => ({
		meta: {
			title: 'Reports',
			disabled: true,
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/annualReport/reports/Layout')).default }),
	children: [
		{
			path: 'pnl',
			index: true,
			id: 'annualReportPnlReport',
			loader: () => ({
				meta: {
					title: 'Profit and Loss',
					htmlTitle: 'Annual Report Profit and Loss Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/annualReport/reports/pages/PnL')).default }),
		},
		{
			path: 'mailing',
			index: true,
			id: 'annualReportMailingReport',
			loader: () => ({
				meta: {
					title: 'Mailings',
					htmlTitle: 'Annual Report Mailing Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/annualReport/reports/pages/Mailing')).default }),
		},
		{
			path: 'order',
			index: true,
			id: 'annualReportOrderReport',
			loader: () => ({
				meta: {
					title: 'Order',
					htmlTitle: 'Annual Report Order Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/annualReport/reports/pages/Order')).default }),
		},
		{
			path: 'order/date',
			index: true,
			id: 'annualReportOrderByDateReport',
			loader: () => ({
				meta: {
					title: 'Order By Date',
					htmlTitle: 'Annual Report Order By Date Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/annualReport/reports/pages/OrderByDate')).default }),
		},
	],
};
export default route;
